import { useTranslation } from "react-i18next";
import { dysfunctions } from "@/lib/treatmentsData";

const CATEGORIES = ["facial", "corporal", "pele"];

export const DysfunctionFilters = ({ selected, onChange }) => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <p className="text-xs text-muted-foreground">{t("treatments.filterByDysfunction")}</p>
        {selected && (
          <button onClick={() => onChange(null)} className="text-xs text-primary hover:underline" data-testid="clear-filter-btn">
            {t("treatments.clearFilter")}
          </button>
        )}
      </div>
      {CATEGORIES.map((cat) => {
        const items = dysfunctions.filter((d) => d.category === cat);
        if (items.length === 0) return null;
        return (
          <div key={cat} className="mb-3">
            <p className="text-[10px] uppercase tracking-wider text-muted-foreground/70 mb-1.5">
              {t(`treatments.categories.${cat}`)}
            </p>
            <div className="flex gap-2 flex-wrap">
              {items.map((d) => (
                <button
                  key={d.id}
                  onClick={() => onChange(selected === d.id ? null : d.id)}
                  className={`text-xs px-3 py-1.5 rounded-full border transition-colors ${selected === d.id ? 'bg-primary text-primary-foreground border-primary' : 'bg-card border-border text-muted-foreground hover:border-primary/50'}`}
                  data-testid={`filter-${d.id}`}
                >
                  {t(`treatments.dysfunctions.${d.id}`)}
                </button>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};
